export const PAGE_TITLE = 'Rondas de Negocios';
